import { IActionResponseData, IActionResponseOutcome } from '@GFTypes/Responses/ActionResponse';

export const processGambleResponse = (data: IActionResponseData): IActionResponseOutcome => {
    if (data.error) throw new Error('Spin request error: ' + data.error);
    const clone = structuredClone(Array.isArray(data.result.outcome) ? data.result.outcome[0] : data.result.outcome);

    return clone;
};
